import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OcApp } from "./OcApp";
import { OcToastProvider } from "./components/shared/OcToast";
import { OcErrorBoundary } from "./components/shared/OcErrorBoundary";
import "./styles/oc-globals.css";

const ocQueryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 2 },
  },
});

ReactDOM.createRoot(document.getElementById("oc-root")!).render(
  <React.StrictMode>
    <OcErrorBoundary>
      <QueryClientProvider client={ocQueryClient}>
        <BrowserRouter>
          <OcToastProvider>
            <OcApp />
          </OcToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </OcErrorBoundary>
  </React.StrictMode>
);
